import { render, staticRenderFns } from "./WarningModal.vue?vue&type=template&id=65f9a2ca&"
import script from "./WarningModal.vue?vue&type=script&lang=js&"
export * from "./WarningModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports